import { render, staticRenderFns } from "./InvoiceTabList.vue?vue&type=template&id=47f4fac6"
import script from "./InvoiceTabList.vue?vue&type=script&lang=js"
export * from "./InvoiceTabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f4fac6')) {
      api.createRecord('47f4fac6', component.options)
    } else {
      api.reload('47f4fac6', component.options)
    }
    module.hot.accept("./InvoiceTabList.vue?vue&type=template&id=47f4fac6", function () {
      api.rerender('47f4fac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sinvoice_viettel/invoice-management/tabs/InvoiceTabList.vue"
export default component.exports